import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { Link } from "react-router-dom";

const CTA = () => {
  const { t } = useLanguage();
  
  return (
    <section className="py-12 md:py-16 bg-primary/5" aria-labelledby="cta-heading">
      <div className="container mx-auto px-4 sm:px-6 md:px-8 lg:px-12 text-center max-w-3xl">
        <h2 id="cta-heading" className="text-2xl sm:text-3xl font-bold text-foreground mb-4 break-words">
          {t('cta.title')}
        </h2>
        <p className="text-base sm:text-lg text-muted-foreground mb-6 md:mb-8 break-words">
          {t('cta.subtitle')}
        </p>
        <Link 
          to="/contact"
          className="inline-flex items-center justify-center bg-accent hover:bg-accent/90 text-accent-foreground shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105 text-lg px-8 py-6 min-h-[44px] rounded-md font-medium"
          aria-label={t('cta.button')}
        >
          {t('cta.button')}
          <ArrowRight className="ml-2 w-5 h-5" aria-hidden="true" />
        </Link>
      </div>
    </section>
  );
};

export default CTA;
